import styled from "styled-components";

export const Button = styled.button`
  color: ${props => props.theme.primary};
  background: transparent;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  cursor: pointer;
  transition: background 0.1s 0.1s;
  user-select: none;
  position: relative;
  border: none;
  box-shadow: none;
  outline: none;

  i,
  a {
    margin: auto;
    font-size: 18px;
    line-height: 18px;
  }

  &:hover,
  &:focus {
    background: ${props => props.theme.primaryTransparent(0.1)};
    transition-delay: 0s;
  }

  &:active {
    background: ${props => props.theme.primaryTransparent(0.25)};
    transition: none;
  }

  &.black {
    color: rgba(20, 20, 20, 1);

    &:hover,
    &:focus {
      background: rgba(20, 20, 20, 0.1);
    }

    &:active {
      background: rgba(20, 20, 20, 0.25);
    }
  }

  &.with-tooltip {
    &:after {
      content: attr(data-custom-tooltip);
      color: white;
      background: ${props => props.theme.primary};
      padding: 1px 6px 0 6px;
      margin: 0 4px;
      border-radius: 3px;
      z-index: 10;
      position: absolute;
      left: 105%;
      white-space: nowrap;
      line-height: 20px;
      font-size: 13px;
      pointer-events: none;
      transform: scale(0);
      transition: all 0.12s;
    }

    &.black:after {
      background: #333;
    }

    &.left {
      &:after {
        right: 105%;
        left: initial;
      }
    }

    &:hover:after {
      transform: scale(1);
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/IconButton/style.js